import { render, staticRenderFns } from "./PageSettleCan.vue?vue&type=template&id=702f6f48&scoped=true"
import script from "./PageSettleCan.vue?vue&type=script&lang=js"
export * from "./PageSettleCan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f6f48",
  null
  
)

export default component.exports